// "use strict";//js严格模式

import Vue from "vue";
import axios from "axios";
import router from "../router/index.js";

/* 0测试、1生产 */
let baseUrl = 1

let jft, fy, captain, allap;
if (baseUrl == 0) {
  //测试环境
  /*ajax配置*/
  // axios.defaults.baseURL = 'https://hr-api-test.xyjhr.cn'; // 测试环境
  // axios.defaults.baseURL = "http://192.168.31.29:38086"; //雅楠本地
  // axios.defaults.baseURL = 'http://8.130.141.215:24107'; //正式IP
  // axios.defaults.baseURL = 'http://localhost:38086'; // 雅楠
} else if (baseUrl == 1) {
  //生产环境
  /*ajax配置*/
  //  axios.defaults.baseURL = 'http://47.92.115.39:18086/'; //本地 - 孙
  // axios.defaults.baseURL = "https://shop-test-api.xyjhr.cn"; //康 测试
  axios.defaults.baseURL = "https://shop-api.xyjhr.cn";
}

axios.defaults.headers.common["token"] = localStorage.getItem("token"); // 设置请求头为 Authorization

localStorage.setItem("headersAppTag", ""); //全部

axios.defaults.timeout = 150000;
//axios拦截器，目的是为了在请求头上带上token
axios.interceptors.request.use(
  (config) => {
    // 拦截的数据
    let token = localStorage.getItem("token");
    if (token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.token = `${token}`;
    }
    // FormData 上传需由浏览器自动设置 Content-Type（含 boundary）
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = false;
    }
    // 将 officeUid 和 objUid 添加到请求体参数中
    const officeUid = localStorage.getItem("uid");
    const objUid = localStorage.getItem("objUid");
    console.log(config, "config");
    // 判断config.url里面不存在api/office/list,api/login api/getLoginInfoList 且officeUid和objUid存在
    if (
      !config.url.includes("api/office/list") &&
      !config.url.includes("api/login") &&
      !config.url.includes("api/getLoginInfoList") &&
      !config.url.includes("api/stock/queryAppleOrder") &&
      !config.url.includes("api/stock/queryOneAppleOrder") &&
      officeUid &&
      objUid
    ) {
      if (
        config.method === "post" ||
        config.method === "put" ||
        config.method === "patch"
      ) {
        // 对于 POST、PUT、PATCH 请求，添加到请求体中
        if (config.data) {
          if (
            typeof config.data === "object" &&
            !(config.data instanceof FormData)
          ) {
            config.data.officeUid = officeUid;
            config.data.objUid = objUid;
          } else if (config.data instanceof FormData) {
            config.data.append("officeUid", officeUid);
            config.data.append("objUid", objUid);
          }
        } else {
          config.data = {
            officeUid: officeUid,
            objUid: objUid,
          };
        }
      } else {
        // 对于 GET、DELETE 等请求，添加到查询参数中
        config.params = config.params || {};
        config.params.officeUid = officeUid;
        config.params.objUid = objUid;
      }
    }

    return config;
  },
  (err) => {
    return config;
  }
);
// 添加响应拦截器
axios.interceptors.response.use(
  function(response) {
    // 响应的数据
    if (response.data.code == "401") {
      layer.open({
        content: "登录超时，请重新登录",
        skin: "msg",
        time: 2,
      });
      router.push("/");
      localStorage.clear();
      console.log(2, "401");
    } else {
      return response;
    }
  },
  function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

Vue.prototype.axios = axios;



// WEBPACK FOOTER //
// ./src/plugins/axios.js